<template>
  <div id="aboutPage">
    <div class="about-con">
      <!-- about-section01 start -->
      <div class="about-section01">
        <div class="blockW">
          <div class="t-center">
            <img src="~assets/img/logo_zqb.png" alt />
          </div>
          <div class="about-describe">
            <p
              class="txt-type02 mb20"
            >深圳中青宝互动网络股份有限公司(原深圳市宝德网络技术有限公司)成立于2003年，是一家具有自主研发、运营能力、代理能力的专业化网络游戏公司。</p>
            <p
              class="txt-type02 mb20"
            >中青宝经过多年发展，凭借着深厚的积淀在国内网络游戏研发、运营领域处于一流旗舰地位。公司现有员工900多人，其中研发人员占70%以上，拥有雄厚的研发基础、文化底韵及资金资源，成为主导网游界风云的重要力量之一。</p>
            <p
              class="txt-type02"
            >中青宝作为国内资深游戏厂商，集研发、运营、发行为一体，拥有多年游戏营运经验及众多游戏IP产品，丰富的内容支撑是中青宝布局云游戏的重要力量，此外，集团涵盖的服务器与云计算业务，更为中青宝云游戏奠定了基础。同时中青宝也将致力于推动云游戏产业的发展，联手合作伙伴共同开发云游戏市场，以“探索、协作、共生”的态度，为云游戏时代构划一个健康的生态环境，为玩家提供更好的游戏体验。</p>
          </div>
        </div>
      </div>
      <!-- about-section01 end -->

      <!-- about-section02 start -->
      <div class="about-section02">
        <div class="blockW">
          <div class="about-unit">
            <div class="main-title main-title22">
              <h2>5G云游戏产业联盟理事单位</h2>
            </div>
            <dl class="unit-msg clearfix">
              <dt>
                <img src="~assets/img/about/img_5G.png" alt />
              </dt>
              <dd>
                <p class="txt-type02 mb20">2019年12月16日，中青宝正式加入5G云游戏产业联盟，成为联盟重要的理事单位之一。</p>
                <p
                  class="txt-type02"
                >5G云游戏产业联盟是在中国互联网协会、电信终端产业协会的共同指导下，由国内外信息通信行业、互联网行业、数字娱乐行业、高校和科研机构等各行业领军企业和单位共同发起成立的，为打造中国云游戏全产业链上下游合作共赢为目的的联盟组织。</p>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <!-- about-section02 end -->

      <!-- about-contact start -->
      <div class="about-contact">
        <div class="blockW">
          <div class="main-title main-title12">
            <h2>联系我们</h2>
          </div>
          <ul class="about-contact-msg">
            <li>
              <i class="icon icon-tel"></i>0755-26520977
            </li>
            <li>
              <i class="icon icon-fax"></i>21618822
            </li>
            <li>
              <i class="icon icon-email"></i>518057
            </li>
            <li>
              <i class="icon icon-address"></i>深圳市南山区高新南十道深圳湾科技生态园3期10栋A座21、23层
            </li>
          </ul>
        </div>
      </div>
      <!-- about-contact end -->
    </div>
  </div>
</template>
<script>
export default {
  name:'aboutus'
}
</script>
<style scoped lang='scss'>
#aboutPage {
  background:#202E40 url('~assets/img/about/bg.jpg') no-repeat center top;
  // background-image: url('~assets/img/body_bg.jpg');

  // width:100%;
  // height: 100%;
  margin-top: -80px;
}
.about-section01 {
  padding: 160px 0;
}
.about-describe {
  width: 800px;
  margin: 80px auto 0;
  color: #fff;
}
.about-describe p {
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1px;
}
.unit-msg {
  height: 368px;
  margin-top: 80px;
  background: url(~assets/img/about/linebg.png) no-repeat center bottom;
}
.unit-msg dt {
  float: left;
  width: 272px;
  height: 208px;
  margin: 0 99px 0 128px;
}
.unit-msg dd {
  float: left;
  width: 500px;
  padding-top: 20px;
}
.about-contact {
  height: 392px;
  background: url(~assets/img/about/contact_bg.jpg) no-repeat center top;
}
.about-contact .blockW {
  padding: 122px 0;
}
.about-contact-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}
.about-contact-msg li {
  padding: 0 14px;
  font-size: 16px;
  line-height: 36px;
}
.about-contact .icon {
  display: inline-block;
  width: 36px;
  height: 36px;
  margin-right: 10px;
  background: url(~assets/img/main_bg.png) no-repeat;
  vertical-align: middle;
}
.about-contact .icon-tel {
  background-position: 0 -32px;
}
.about-contact .icon-fax {
  background-position: -40px -32px;
}
.about-contact .icon-email {
  background-position: -80px -32px;
}
.about-contact .icon-address {
  background-position: -120px -32px;
}
.about-contact .icon-email02 {
  background-position: -160px -32px;
}
.about-contact .icon-business {
  background-position: -200px -32px;
}
.blockW{
      width: 1200px;
    margin: 0 auto;
}
.t-center {
  text-align: center;
  img{
    margin: 0 auto;
  }
   
}
.main-title22 h2{
  margin: 0 auto;
  width: 510px;
  background-position: 0 -920px;
}
.main-title12 h2{
  margin: 0 auto;
  width: 158px;
  background-position: 0 -440px;
}
// .main-title12 h2{
//   background-position: 0 -920px;
// }
.mb20{
  margin-bottom: 20px;
}
</style>